/**
 * Format date string or Date to readable format
 */
export function format(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return '-';
  
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

/**
 * Format date to ISO string for API
 */
export function toISODate(date: Date): string {
  return date.toISOString().split('T')[0];
}
